import React, { useState } from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allPlansHeaders } from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { GlobalPlansHooks } from "./hooks/GlobalPlansHooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import AddPlansModal from "./AddPlanModal";
import { useSelector } from "react-redux";

function AllPlans({church}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData, fetchAllPlans } =
    GlobalPlansHooks();
   const { userInfo } = useSelector((state) => state.user);

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  // ✅ modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // store row for edit/view

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
      {!hideUI && <Navbar />}

      <div className={`flex-1 ${!hideUI && "md:pl-32"} md:pt-0 pt-20`}>
        <div className="flex flex-col gap-4 h-full">
          {!hideUI && (
            <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
          )}

          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className={`flex w-full ${!hideUI?'justify-between':'justify-end'} md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2`}>
             {!hideUI && <p className=" text-white text-3xl font-medium">Plans</p>}
              <div className="flex gap-4">
                {!hideUI &&
                  <Link to={"/plans/add"}>
                    <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                      <AiOutlinePlus /> Add Plan
                    </button>
                  </Link>
           }
              </div>
            </div>

            <div className={`${hideUI && 'relative'}`}>
              { hideUI &&
            <div className="flex gap-4 absolute right-0 mt-2">
            <button
                    onClick={() => {
                      setSelectedRow(null); // new plan
                      setIsModalOpen(true);
                    }}
                    className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                  >
                    <AiOutlinePlus /> Add Plan
                  </button>
</div>
}
              <CustomTable
                searchFor="Plans"
                heightDesktop={"h-[72vh]"}
                width={"w-24"}
                nthChildWidth={
                  "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(3)]:w-32"
                }
                notificationTable={true}
                data={[]}
                headers={allPlansHeaders}
                customDataFetch={true}
                customDataFetchFunction={(page, limit, searchCriteria, callback) =>
                  fetchAllPlans(page, limit, searchCriteria, callback, "", 1)
                }
                reloadData={reloadData}
                setReloadData={setReloadData}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => (
                      <ConfirmToast
                        title="Are you sure?"
                        message="You want to delete this plan?"
                        onClose={() => onClose()}
                        onSuccess={() => {
                          handleDelete(row);
                          onClose();
                        }}
                      />
                    ),
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };
                  confirmAlert(options);
                }}
                reverseTable={true}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row); // pass row into modal
                    setIsModalOpen(true);
                    // navigate("#", { state: { _id: row?._id || "" } });


                  } else {
                                        navigate("/plans/add", { state: row });
                  }
                }}

                handleEditClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row); // pass row into modal
                    setIsModalOpen(true);
                  } else {
                    navigate("/plans/add", { state: row });
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Add Plans Modal (only shows when hideUI === true) */}
      {hideUI && (
        <AddPlansModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedRow(null);
            setReloadData((prev) => !prev); // refresh table
          }}
          rowData={selectedRow}
          hideUI={hideUI}
          church={church}
        />
      )}
    </div>
  );
}

export default AllPlans;
